import Container from "@mui/material/Container";
import React, {useMemo} from "react";
import { NotificationContainer } from 'react-notifications';
import { Link, Navigate, Route, Routes as RouterRoutes } from "react-router-dom";
import { Administration } from "../admin/Administration";
import { ConfirmationContextProvider } from "../shared/contexts/ConfirmationContext";
import {Dashboard} from "../dashboard/Dashboard";
import Declaration from "../declaration/Declaration";
import ErrorPage from "../Error/ErrorPage";
import {NewEvent} from "../event/NewEvent";
import { Loading } from "../shared/components/loading/Loading";
import PrivateRoute from "../shared/components/PrivateRoute";
import { AuthContextProvider } from "../shared/contexts/AuthContext";
import AppErrorBoundary from "../shared/helpers/AppErrorBoundary";
import Page2 from "../shared/mock/FormExample";
import auth from "../shared/services/authentification/authentificationService";
import Ui from "../ui/Ui";
import RefDataController from "./../shared/controllers/RefDataController";
import { Header } from "./Header";
import LoadingContext from "./LoadingContext";
import EventController from "../shared/controllers/EventController";

const Routes = () => {
  const [showLoading, setShowLoading] = React.useState(false);

  const loadingCtx = {
    startLoading: () => setShowLoading(true),
    stopLoading: () => setShowLoading(false),
  };

  const cancel = () => {
     setShowLoading(false);
  };

  const termsOfUsePath = () =>{
    return `${process.env.PUBLIC_URL}/assets/docs/2021-06_TermsOfUse-EventDeclaration.pdf`;
  }
 
  const year = useMemo(()=> new Date().getFullYear(), [])

  const version = useMemo( () => String(process.env.REACT_APP_VERSION), []);

  return (
    <>
      <LoadingContext.Provider value={loadingCtx}>
        <AppErrorBoundary>
          <ConfirmationContextProvider>
            <AuthContextProvider>
              <RefDataController>
                <EventController>
                  <Header />
                  <RouterRoutes>
                    {/* Redirect root to dashboard */}
                    <Route path="/" element={<PrivateRoute><Navigate to="/dashboard" replace /></PrivateRoute>} />

                    <Route path="/page2/index" element={<PrivateRoute><Page2 /></PrivateRoute>} />
                    <Route path="/Page2/index/:id" element={<PrivateRoute><Page2 /></PrivateRoute>} />
                    <Route path="/dashboard/event/new" element={<PrivateRoute><NewEvent /></PrivateRoute>} />
                    <Route path="/dashboard/event/:mode/:id" element={<PrivateRoute><NewEvent /></PrivateRoute>} />
                    <Route path="/admin" element={<PrivateRoute><Administration /></PrivateRoute>} />
                    <Route path="/dashboard/event/:mode/:id/:idd/readonly" element={<PrivateRoute><Declaration /></PrivateRoute>} />
                    <Route path="/dashboard/event/:mode/:id/:idd" element={<PrivateRoute><Declaration /></PrivateRoute>} />
                    <Route path="/declaration/:id" element={<PrivateRoute><Declaration /></PrivateRoute>} />
                    <Route path="/declaration/new" element={<PrivateRoute><Declaration /></PrivateRoute>} />
                    <Route path="/declaration/forms/:id" element={<PrivateRoute><Declaration /></PrivateRoute>} />
                    <Route path="/declaration/Read/:id" element={<PrivateRoute><Declaration /></PrivateRoute>} />
                    <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />

                    {/* TODO: For Dev UI only, need to be delete at the end*/}
                    <Route path="/ui" element={<PrivateRoute><Ui /></PrivateRoute>} />

                    <Route path="/dashboardProtected" element={<PrivateRoute><Dashboard /></PrivateRoute>} />

                    {/* Error page */}
                    <Route path="/Error" element={<ErrorPage />} />

                    {/* Not Found - catch all */}
                    <Route path="*" element={<PrivateRoute><Navigate to="/" replace /></PrivateRoute>} />
                  </RouterRoutes>
                </EventController>
              </RefDataController>
              {false && (
                <nav>
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/Page2/index">Page 2</Link>
                    </li>
                    <li>
                      <Link to="/Page2/index/2">Page 2 with id</Link>
                    </li>
                    <li>
                      <Link to="/declaration/new">Declaration New</Link>|{" "}
                      <Link to="/declaration/1">Edit</Link>|{" "}
                      <Link to="/declaration/forms">Forms</Link>|{" "}
                      <Link to="/declaration/read/33">Read</Link>
                    </li>
                    <li>
                      <Link to="/dashboard/event/new">New event</Link>
                      <Link to="/dashboard/event/edit/2"> New event edit</Link>
                      <Link to="/dashboard/event/readonly/2">
                        {" "}
                        New event readonly
                      </Link>
                    </li>
                    <li>
                      <Link to="/dashboard">Dashboard</Link>
                    </li>

                    <li>
                      <Link to="/dashboardProtected">Dashboard Protected</Link>
                    </li>
                    <li onClick={() => auth.logOut()}>
                      <Link to="/">logout</Link>
                    </li>
                    <li onClick={() => auth.signIn()}>
                      <Link to="/">signIn</Link>
                    </li>
                  </ul>
                </nav>
              )}
              {showLoading && <Loading cancel={cancel}/>}
              <footer className="footer">
                <Container maxWidth="xl">
                  <div className="footer-content">
                    <span id="footer-copyright">© Richemont {year} - {version}</span>
                    <div>
                      <a className="footer-link" href={termsOfUsePath()} target="_blank" rel="noreferrer">
                        Term of use
                      </a>
                      <a className="footer-link" href={termsOfUsePath()} target="_blank" rel="noreferrer">
                        Privacy Policy
                      </a>
                    </div>
                  </div>
                </Container>
              </footer>
              <NotificationContainer />
            </AuthContextProvider>
          </ConfirmationContextProvider>
        </AppErrorBoundary>
      </LoadingContext.Provider>
    </>
  );
};


export default Routes;
